import r from '../../services/Replacement';

export type ReleaseNote = {
    href: string;
    menuItem: string;
    teaser: string;
    date: `${number}-${number}-${number}`;
};

export const releaseNotes: ReleaseNote[] = [
    {
        href: 'https://www.small-improvements.com/release-notes/#note-308066',
        menuItem: 'eNPS',
        teaser: 'New in Pulse Surveys: Track eNPS scores',
        date: '2026-08-07',
    },
    {
        href: 'https://www.small-improvements.com/release-notes/#note-308106',
        menuItem: 'Talent Box',
        teaser: `New in ${r('pr.menu.title')}: Talent Box Display`,
        date: '2026-07-07',
    },
    {
        href: 'https://www.small-improvements.com/features/ai-coach-overview/',
        menuItem: 'AI Coaches',
        teaser: `New: Fine-tune AI Coaches for ${r('pr.menu.title')}`,
        date: '2026-06-25',
    },
    {
        href: 'https://www.small-improvements.com/release-notes/#note-305928',
        menuItem: 'Outlier Detection',
        teaser: `New in ${r('pr.menu.title')}: Detect Outliers`,
        date: '2026-06-02',
    },
];
